/* eslint-disable arrow-body-style */

import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    apiKey: null,
    loading: false,
  },
  mutations: {
    setApiKey: (state, apiKey) => {
      state.apiKey = apiKey;
    },
    clearState: (state) => {
      state.apiKey = null;
    },
  },
  getters: {
    apiKeySet: (state) => {
      return state.apiKey !== null;
    },
  },
});
